import React, {useState, useEffect} from 'react'
import { Link } from 'react-router-dom'
import {collection, getDocs, deleteDoc, doc, query, orderBy} from 'firebase/firestore'
import {db} from '../../firebase'
import '../../Styles/admin.css'
import moment from "moment";
import 'moment/locale/es';

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

 const Show = () => {

    const [products, setProducts] = useState( [] )

    const productsCollection = collection(db, "productos")


    const q = query(
            productsCollection,
            orderBy("fecha","desc")
        //,limit(22)
    );

    const getProducts = async () => {
        const data = await getDocs(q)
        setProducts(
            data.docs.map( (doc) => ({...doc.data(), id:doc.id}))
        )
        //console.log(products)
    }

    const deleteProduct = async (id) => {
        const productDoc = doc(db, "productos", id)
        await deleteDoc(productDoc)
        getProducts()
    }

    const confirmDelete = (id) => {
        MySwal.fire({
            title: 'Estas seguro?',
            text: "Una vez borrado, no se podra recuperar.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, borrarlo.'
          }).then((result) => {
            if (result.isConfirmed) {
                deleteProduct(id)
              Swal.fire(
                'Borrado!',
                'El registro fue borrado. 😃',
                'success'
              )
            }
          })
    }

    useEffect( () => {
        getProducts()
    }, [])

  return (
    <>
        <div className="containe admin">
            <div className="row">
                <div className="col">
                    <div className="d-grid gap-2">
                        <Link to='/admin/create' className="btn btn-success mt-2 mb-2">Crear Producto</Link>
                    </div>
                    <div className="table-responsive">
                        <table id='tablaProductos' className="table table-dark table-hover">
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Nombre</th>
                                    <th>Categoria</th>
                                    <th>Sub Categoria</th>
                                    <th>Precio</th>
                                    <th>Stock</th>
                                    <th>Fecha_registro</th>
                                    <th></th>
                                    <th></th>
                                    {/* <th>Observación</th> */}
                                </tr>
                            </thead>
                            <tbody>
                            {
                                products.length > 0 ? (
                                products.map(item => (
                                    <tr key={item.id}>
                                        <td>{item.id}</td>
                                        <td>{item.nombre}</td>
                                        <td>{item.categoria}</td>
                                        <td>{item.subcategoria}</td>
                                        <td>S/.{item.precio}</td>
                                        <td>{item.stock}</td>
                                        <td>{moment(item.fecha).format('L')}</td>
                                        {/*<td>{item.observacion}</td> */}
                                        <td>
                                            <Link to={`/admin/edit/${item.id}`} className='btn btn-primary'><i className="fa-solid fa-pencil"></i></Link>
                                            
                                        </td>
                                        <td><button onClick={ () => {confirmDelete(item.id)}} className="btn btn-danger"><i className="fa-solid fa-trash"></i></button></td>
                                        
                                    </tr> 
                                ))
                                ) : (
                                <td colSpan={5}>No hay productos registrados.</td>
                                )
                            }
                            </tbody>
                        </table>
                    </div>
                    
                </div>
            </div>
        </div>

    </>

  )
}

export default Show
